/**
 * Determines whether the given classifier type is considered core.
 * @param {string} type - The classifier type string to check.
 * @returns {boolean} `true` if `type` contains "Core"; otherwise `false`.
 */
export function isCoreClassifier(type: string): boolean {
  return !!type?.includes('Core')
}
